import { createApiHooks } from '../common';
import { getAvailableCounters, getCounters } from './api';

const { useGetAvailableCountersQuery, useGetCountersQuery } = createApiHooks({
  name: 'pm',
  queries: {
    getAvailableCounters,
    getCounters
  }
});

export { useGetAvailableCountersQuery, useGetCountersQuery };
